/* ----------- CONTENT START ------------- */

/* global CLOSE_BUTTON, globalData, animationTime, ANIMATIONS, runningMode, TYPES, SPINNER, events, animationDirection, urlHistory, componentHandler, options, google, lazyLoadBackgroundImages, color, sendDataToIOSOverURLCall, MsgBox, CONTENT, urlParams, ratingStars, braintree, CONTENT_TARGET, snackbar, Ratings, Position, LazyLoad, Network, Login, FormValidation, Notification, io, Promise, API_PATH, autocompleete, schema, restCollection, lng */

/**
 * Contains views for the webpage. Objects includes initalization and terminate
 * functions, css class name, title, html code, definitions of actions accorting
 * to events and style definitions according to different window sizes. All that
 * specific per object.
 * <br/><br/>
 * After this some functions are included. <code>size()</code>,
 * <code>getAllObjects()</code> and <code>validateContentArrays()</code>.
 * For more information look for documentation of the specific function.
 * @type Object
 */
const CONTENT = {
  /* ---- Functions start ---- */
  /**
   * Validate all CONTENT items.
   * @returns {Promise}
   */
  init: function () {
    return new Promise((resolve, reject) => {
      const items = getAllContentFromObject(this);
      for (let i in items) {
        //check if item is valid
        const valid = validateObject(this.MODEL, items[i], i);
        if (valid !== true) {
          console.error(valid);
          throw new Error("CONTENT invalid");
        }
      }

      //load html code from html files and include it to the content items
      const htmlLoad = [];
      for (let j in items) {
        htmlLoad.push(
          new Promise((resolve, reject) => {
            Network.request(
              "content/" + j.toLowerCase() + ".html",
              null,
              {
                200: (html) => {
                  items[j].html = html;
                  resolve();
                },
              },
              (err) => {
                const item = items[j];
                item.html = "";
                console.error(
                  "content/" +
                    j.toLowerCase() +
                    ".html could not be found. Used empty string instead."
                );
                resolve();
              }
            );
          })
        );
      }

      Promise.all(htmlLoad)
        .then(() => resolve())
        .catch((exception) => reject());
    });
  },
  /* ---- Functions end ---- */

  /* ---- MODEL END ---- */
  MODEL: {
    css_id: "css id without #",
    data: {},
    functions: {},
    init: function () {},
    close: function () {},
    events: [
      {
        source: "css selector",
        event: "click",
        function: function () {},
      },
    ],
  },
  /* ---- MODEL end ---- */

  /* ---- Contetnt start ---- */
  LOGIN: {
    css_id: "login",
    data: {
      /**
       * Div-Container of the view.
       * @type Element
       */
      container: null,
    },
    functions: {
      checkSession: function () {
        return new Promise((resolve, reject) => {
          const xhr = Network.openXHR("GET", API_PATH + "user/self");
          xhr.onerror = () => reject(xhr);
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (xhr.status !== 200) return reject();

            const user = JSON.parse(xhr.responseText);
            if (user.id) {
              globalData.user = user;
              resolve();
            } else reject();
          };
          xhr.send();
        });
      },
      login: function (login, password) {
        return new Promise((resolve, reject) => {
          const xhr = Network.openXHR("POST", API_PATH + "login");
          xhr.onerror = () => reject(xhr);
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (xhr.status === 200)
              globalData.user = JSON.parse(xhr.responseText).user;

            resolve(xhr);
          };
          xhr.send(JSON.stringify({ login: login, password: password }));
        });
      },
      logout: function () {
        return new Promise((resolve, reject) => {
          const xhr = Network.openXHR("POST", API_PATH + "logout");
          xhr.onerror = () => reject(xhr);
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            globalData.user = null;
            resolve(xhr);
          };
          xhr.send();
        });
      },
      /**
       * Show or hide the private views in the mdl side menu.
       * @param {Boolean} show
       * If <i>true</i> show. Else hide.
       * @returns {undefined}
       */
      loginCb: function (show) {
        const display = show ? "block" : "none";

        /*var privateViews = document.querySelectorAll('.mdl-navigation__link.private');
                 for (var i = 0, len = privateViews.length; i < len; i++)
                 privateViews[i].style.display = display;*/

        const navNodes = document.querySelectorAll(".mdl-navigation__link");
        let i = 0;
        const len = navNodes.length;
        for (; i < len; i++) {
          const node = navNodes[i];
          const viewName = node.dataset.view;

          switch (viewName) {
            case "contract_blueprint":
              if (globalData.user && globalData.user.dashboard_user)
                node.style.display = "none";
              else if (globalData.user && globalData.user.admin)
                //|| globalData.user.manage_partner))
                node.style.display = "block";
              else node.style.display = "none";
              break;
            case "contract":
              if (globalData.user && globalData.user.dashboard_user)
                node.style.display = "none";
              else if (globalData.user && globalData.user.admin)
                //|| globalData.user.manage_partner || globalData.user.partnerGroupManager.length > 0))
                node.style.display = "block";
              else node.style.display = "none";
              break;
            case "dashboard":
              if (globalData.user && globalData.user.dashboard_user) {
                node.style.display = "block";
              } else if (
                globalData.user &&
                (globalData.user.admin ||
                  globalData.user.manage_partner ||
                  (globalData.user.partnerGroupManager &&
                    globalData.user.partnerGroupManager.length > 0) ||
                  (globalData.user.partnerGroup &&
                    globalData.user.partnerGroup.length > 0) ||
                  (globalData.user.partner &&
                    globalData.user.partner.length > 0))
              ) {
                if (node.classList.contains("private"))
                  node.style.display = display;
              } else node.style.display = "none";
              break;
            case "user":
            case "partner":
            case "employee":
            case "customer":
            case "auto_export":
              if (globalData.user && globalData.user.dashboard_user) {
                node.style.display = "none";
              } else if (
                globalData.user &&
                (globalData.user.admin ||
                  globalData.user.manage_partner ||
                  (globalData.user.partnerGroupManager &&
                    globalData.user.partnerGroupManager.length > 0) ||
                  (globalData.user.partnerGroup &&
                    globalData.user.partnerGroup.length > 0) ||
                  (globalData.user.partner &&
                    globalData.user.partner.length > 0))
              ) {
                if (node.classList.contains("private"))
                  node.style.display = display;
              } else node.style.display = "none";
              break;
            case "customer_today":
              if (
                globalData.user &&
                (globalData.user.admin ||
                  globalData.user.login == "cgleymueller")
              ) {
                node.style.display = display;
              } else node.style.display = "none";
              break;
            case undefined:
              if (node.classList.contains("private"))
                node.style.display = display;
              break;
            case "location":
              node.style.display = "none";
              break;
            default:
              if (globalData.user && globalData.user.dashboard_user) {
                node.style.display = "none";
              } else if (
                globalData.user &&
                (globalData.user.admin ||
                  globalData.user.manage_partner ||
                  (globalData.user.partnerGroupManager &&
                    globalData.user.partnerGroupManager.length > 0) ||
                  (globalData.user.partnerGroup &&
                    globalData.user.partnerGroup.length > 0))
              ) {
                if (node.classList.contains("private"))
                  node.style.display = display;
              } else node.style.display = "none";
          }
        }
      },
    },
    init: function (data) {
      //hide menu
      document
        .querySelector(".mdl-layout")
        .classList.remove("mdl-layout--fixed-drawer");
      //init state
      const view = CONTENT.LOGIN;
      const container = document.getElementById(view.css_id);
      view.data.container = container;
      container.classList.add("loading");

      //animation
      ANIMATIONS.getDefaultAnimation()(
        document.querySelectorAll("#" + this.css_id + " .changeViewAnimation")
      );
      try {
        componentHandler.upgradeDom();
      } catch (e) {
        console.error("mdl was not loaded correctly yet", e);
      }

      //check session
      view.functions
        .checkSession()
        .then((xhr) => {
          view.functions.loginCb(true);
          let startContent = runningMode.mode.startContent.content;
          if (startContent === CONTENT.LOGIN) startContent = CONTENT.DASHBOARD;
          CONTENT_TARGET.changeContent(startContent);
        })
        .catch(() => {
          //view.functions.loginCb(false);
          container.classList.remove("loading");
        });
    },
    close: function () {
      //show menu
      document
        .querySelector(".mdl-layout")
        .classList.add("mdl-layout--fixed-drawer");
    },
    events: [
      {
        source: "#login button.ok",
        event: "click",
        function: function () {
          const view = CONTENT.LOGIN;

          const login = document.querySelector(
            "#" + view.css_id + " input[name=login]"
          ).value;
          const password = document.querySelector(
            "#" + view.css_id + " input[name=password]"
          ).value;

          view.functions
            .login(login, password)
            .then((xhr) => {
              switch (xhr.status) {
                case 200:
                  view.functions.loginCb(true);
                  CONTENT_TARGET.changeContent(CONTENT.DASHBOARD);
                  return;
                case 403:
                  snackbar.show({
                    message: "Fehlerhafte Anmeldeinformationen",
                  });
                  break;
                case 404:
                  snackbar.show({
                    message: "Fehlerhafte Anmeldeinformationen",
                  });
                  break;
                case 410:
                  snackbar.show({
                    message: "Fehlerhafte Anmeldeinformationen",
                  });
                  break;
                default:
                  snackbar.show({
                    message: "Fehler in der Kommunikation. Code " + xhr.status,
                  });
                  console.error(xhr);
              }
              view.functions.loginCb(false);
            })
            .catch((xhr) => {
              snackbar.show({
                message: "Ein Fehler in der Kommunikation ist aufgetreten.",
              });
              view.functions.loginCb(false);
            });
        },
      },
      {
        source: "#login input[name=login]",
        event: "keyup",
        function: function (e) {
          if (e.keyCode !== 13) return;

          const view = CONTENT.LOGIN;
          document
            .querySelector("#" + view.css_id + " input[name=password]")
            .focus();
        },
      },
      {
        source: "#login input[name=password]",
        event: "keyup",
        function: function (e) {
          if (e.keyCode !== 13) return;

          const view = CONTENT.LOGIN;
          document.querySelector("#" + view.css_id + " button.ok").click();
        },
      },
    ],
  },
  USER: {
    css_id: "user",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.USER;
      const rest = restCollection.user;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.USER;
      view.data.restView.destroy();
    },
    events: [],
  },
  DASHBOARD: {
    css_id: "dashboard",
    data: {
      restView: null,
      statistics: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.DASHBOARD;
      const root = document.querySelector("#dashboard .container");

      // ################## DEFAULT-DATE-RANGE #########################
      let dateFrom = moment().subtract(7, "days").format("DD.MM.YYYY");

      let dateTo = moment().format("DD.MM.YYYY");
      let timeF = "00:00";
      let timeT = "23:59";

      const fpLocale = {
        weekdays: {
          shorthand: moment.weekdaysShort(),
          longhand: moment.weekdays(),
        },
        months: {
          shorthand: moment.monthsShort(),
          longhand: moment.months(),
        },
        // TODO: lng methode verwenden!
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum Ändern scrollen",
        toggleTitle: "Zum Umschalten klicken",
      };

      const fpRange = document.getElementById("dateFromTo");
      fpRange.disabled = true;

      new Flatpickr(dateFromTo, {
        dateFormat: "d.m.Y",
        mode: "range",
        locale: fpLocale,
        defaultDate: [dateFrom, dateTo],
        maxDate: "today",
        onClose: (selectedDates, dateStr, instance) => {
          const dateFrom = moment(selectedDates[0]).format("DD.MM.YYYY");
          const dateTo = moment(selectedDates[1]).format("DD.MM.YYYY");
          sessionStorage.setItem("dateFrom", dateFrom);
          sessionStorage.setItem("dateTo", dateTo);
          getStatistic(dateFrom, dateTo, timeF, timeT);
        },
      });
      const timeFrom = document.getElementById("timeFrom");
      const timeTo = document.getElementById("timeTo");
      new Flatpickr(timeFrom, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        defaultDate: timeF,
        onClose: (datetime, time, instance) => {
          timeF = time;
          getStatistic(dateFrom, dateTo, timeF, timeT);
        },
      });
      new Flatpickr(timeTo, {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        defaultDate: timeT,
        onClose: (datetime, time, instance) => {
          timeT = time;
          getStatistic(dateFrom, dateTo, timeF, timeT);
        },
      });

      // ################# CREATING-CHARTS ###############################################################################
      const chartOne = new Chart(
        document.querySelector(".chartOne .chart > canvas").getContext("2d"),
        {
          type: "pie",
          data: {
            labels: [],
            datasets: [
              {
                backgroundColor: [],
                data: [],
              },
            ],
          },
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            maintainAspectRatio: false,
            elements: {
              arc: {
                borderWidth: 0,
              },
            },
          },
        }
      );

      const chartTwo = new Chart(
        document.querySelector(".chartTwo .chart > canvas").getContext("2d"),
        {
          type: "line",
          data: {
            labels: [],
            datasets: [],
          },
          options: {
            legend: {
              display: false,
            },
            responsive: true,
            position: "center",
            scales: {
              yAxes: [
                {
                  ticks: {
                    suggestedMin: 0,
                    beginAtZero: true,
                    stepSize: 10,
                  },
                },
              ],
            },
          },
        }
      );
      /*
            var chartThree = new Chart(document.querySelector('.chartThree .chart > canvas').getContext('2d'), {
                type: 'bubble',
                data: {
                    labels: [],
                    datasets: []
                },
                options: {
                    legend:
                    {
                        display: false
                    },
                    responsive: true,
                    scales: {
                        xAxes: [
                            {
                                ticks: {
                                    stepSize: 1
                                }
                            }
                        ],
                        yAxes: [
                            {
                                ticks: {
                                    suggestedMin: 8,
                                    stepSize: 1,
                                    suggestedMax: 16,
                                    callback: function (v, i, a) {
                                        return moment(v, "H").format("H:SS");
                                    }
                                }
                            }
                        ]
                    },
                }
            });
            */
      // ################ GET STATISTICS ################
      let chartData;
      let chartDataSelect;
      Promise.all([
        restCollection.statistic.dashboardData(),
        restCollection.statistic.statistic({
          startDate: dateFrom,
          endDate: dateTo,
          startTime: timeF,
          endTime: timeT,
        }),
      ]).then((data) => {
        this.data.statistics = data;
        chartData = new ChartDataX(data[0]);
        chartData.setStatistic(data[1]);

        chartDataSelect = new ChartDataSelectX(chartData);
        chartDataSelect.addRef(
          document.querySelector(".dataChooserContainer .partnerGroup > select")
        );
        chartDataSelect.addRef(
          document.querySelector(".dataChooserContainer .partner > select")
        );
        chartDataSelect.addRef(
          document.querySelector(".dataChooserContainer .form > select")
        );
        chartDataSelect.addRef(
          document.querySelector(".dataChooserContainer .location > select")
        );
        chartDataSelect.addRef(
          document.querySelector(".dataChooserContainer .employee > select")
        );
        chartDataSelect.addRef(
          document.querySelector(".dataChooserContainer .active > input")
        );
        chartDataSelect.addRef(
          document.querySelector(
            ".dataChooserContainer .active-employee > input"
          )
        );
        ChartDataSelectX.afterChange = (e) => {
          chartData.setStatistic(this.data.statistics[1]);

          if (e && e.target) {
            const type = ChartDataSelectX.classToType(
              e.target.parentElement.className
            );
            chartDataSelect.setOptions(type);
          } else {
            chartDataSelect.setOptions();
          }

          ChartPie(
            chartOne,
            chartDataSelect,
            document.querySelector(".chartOne .chartContainer")
          );
          ChartLine(
            chartTwo,
            chartDataSelect,
            document.querySelector(".chartTwo .chartContainer"),
            dateFrom,
            dateTo
          );
          //ChartBubble(chartThree, chartDataSelect, document.querySelector('.chartThree .chartContainer'), dateFrom, dateTo )
        };

        ChartDataSelectX.afterChange();

        fpRange.disabled = false;
      });

      function getStatistic(from, to, fromtime, totime) {
        dateFrom = from;
        dateTo = to;
        timeF = fromtime;
        timeT = totime;
        restCollection.statistic
          .statistic({
            startDate: from,
            endDate: to,
            startTime: fromtime,
            endTime: totime,
          })
          .then((data) => {
            CONTENT.DASHBOARD.data.statistics[1] = data;
            chartData.setStatistic(data);
            ChartDataSelectX.afterChange();
          });
      }
    },
    close: function () {},
    events: [],
  },
  PARTNER_GROUP: {
    css_id: "partner_group",
    data: {
      restView: undefined,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.PARTNER_GROUP;
      const rest = restCollection.partnerGroup;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.PARTNER_GROUP;
      view.data.restView.destroy();
    },
    events: [],
  },
  PARTNER: {
    css_id: "partner",
    data: {
      /**
       * @type {RestView}
       */
      restView: null,
    },
    functions: {},
    init: function (data) {
      let view = CONTENT.PARTNER;
      let rest = restCollection.partner;
      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.PARTNER;
      view.data.restView.destroy();
    },
    events: [],
  },
  CUSTOMER: {
    css_id: "customer",
    data: {
      restView: null,
      formFilter: null,
      forms: null,
      allCustomers: null,
    },
    functions: {
      clearFilterSelect: function (select) {
        select.selectedIndex = 0;
        select.data = 0;
        Array.from(select.children)
          .filter((option) => option.data)
          .forEach((option) => select.removeChild(option));
      },
      getPrenameFromForm: function (data) {
        data = JSON.parse(data);
        let name = "";
        data
          .filter(
            (i) =>
              (i.name === "Name" || i.name === "Name ") &&
              i.data &&
              i.data.length > 1
          )
          .forEach((i) => {
            if (
              i.data[0].name.toLowerCase().includes("vorname") ||
              i.data[0].name.toLowerCase() === "vname"
            ) {
              name = i.data[0].val;
            } else if (
              i.data[1].name.toLowerCase().includes("vorname") ||
              i.data[1].name.toLowerCase() === "vname"
            ) {
              name = i.data[1].val;
            }
          });
        return name;
      },
      getSurnameFromForm: function (data) {
        data = JSON.parse(data);
        let name = "";
        data
          .filter(
            (i) =>
              (i.name === "Name" || i.name === "Name ") &&
              i.data &&
              i.data.length > 1
          )
          .forEach((i) => {
            if (
              i.data[1].name.toLowerCase().includes("nachname") ||
              i.data[1].name.toLowerCase().includes("zuname") ||
              i.data[1].name.toLowerCase() === "name"
            ) {
              name = i.data[1].val;
            } else if (
              i.data[0].name.toLowerCase().includes("nachname") ||
              i.data[0].name.toLowerCase().includes("zuname") ||
              i.data[0].name.toLowerCase() === "name"
            ) {
              name = i.data[0].val;
            }
          });
        return name;
      },
      removeAllIcons() {
        let allIcons = document.querySelectorAll(
          "#customer .material-icons.sorting-icon"
        );
        allIcons = Array.from(allIcons);
        allIcons.map((icon) => {
          icon.parentNode.removeChild(icon);
        });
      },
      renderCustomerTable: function (view) {
        const table = document.querySelector(`#${view.css_id} table.found`);
        const tbody = table.querySelector("tbody");
        tbody.innerHTML = null;

        const trs = [];
        const formToHtml = view.functions.formToHtml;
        const getPrenameFromForm = view.functions.getPrenameFromForm;
        const getSurnameFromForm = view.functions.getSurnameFromForm;
        let counter = 1;

        view.data.allCustomers.map((c) => {
          var tr = document.createElement("tr");
          tr.data = c;

          if (c.locationPartner) {
            tr.insertAdjacentHTML(
              "beforeend",
              `
                                    <td>${counter++}</td>
                                    <td><input type="checkbox" name="export" value="${
                                      c.id
                                    }" checked /></td>
                                    <td>${c.locationPartner.location.name}</td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
            );
          } else {
            tr.insertAdjacentHTML(
              "beforeend",
              `
                                    <td>${counter++}</td>
                                    <td><input type="checkbox" name="export" value="${
                                      c.id
                                    }" checked /></td>
                                    <td></td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
            );
          }

          tr.children[tr.children.length - 1].appendChild(formToHtml(c.data)); //put parsed json to last td of this row
          trs.push(tr);
        });
        requestAnimationFrame(() => {
          trs.map((tr) => tbody.appendChild(tr));
        });
      },
      formToHtml: function (data) {
        data = JSON.parse(data);
        const container = document.createElement("div");
        const table = document.createElement("table");
        table.classList.add("dataset");

        const html = [];
        const signs = []; //stores the paths of signs in the same order like the buttons. The buttons has the attribute data-signIndex to access this array

        //TODO the CPU bottle neck is inside this mal function
        data.map((i) => {
          html.push(`<tr><td>${i.name}</td><td>`);

          if (Array.isArray(i.data)) {
            if (i.data[0] && typeof i.data[0] === "string") {
              html.push("<table>");
              html.push(`<tr><td>${i.data[0]}</td><td></td></tr>`);
              html.push("</table>");
            } else {
              html.push("<table>");
              i.data.map((j) =>
                html.push(`<tr><td>${j.name}</td><td>${j.val}</td></tr>`)
              );
              html.push("</table>");
            }
          } else if (i.val || i.val === "") {
            html.push("<table>");
            html.push(`<tr><td>${i.name}</td><td>${i.val}</td></tr>`);
            html.push("</table>");
          } else {
            let path = i.data.path;
            if (path !== undefined && path.substr(0, 2) === "x,") {
              // -- sign --
              html.push(
                `<button class="sign" data-signIndex="${signs.length}">Unterschrift anzeigen</button>`
              );
              signs.push(path);
            } else {
              html.push("<table>");
              for (let j in i.data) {
                if (typeof i.data[j] === "boolean")
                  html.push(
                    html.push(
                      `<tr><td>${lng.get(j)}</td><td>${
                        i.data[j] ? "Ja" : "Nein"
                      }</td></tr>`
                    )
                  );
                else
                  html.push(
                    `<tr><td>${lng.get(j)}</td><td>${i.data[j]}</td></tr>`
                  );
              }
              html.push("</table>");
            }
          }

          html.push(`</td></tr>`);
        });

        //innerHTML is lightly faster then insertadjacenthtml
        table.innerHTML = html.join("");
        //table.insertAdjacentHTML('beforeend', html.join(''));
        table.signs = signs;
        container.appendChild(table);
        return container;
      },
      updateSelectWidth: function (select, text) {
        if (
          select.selectedIndex === 0 &&
          select.options[select.selectedIndex].innerHTML === text
        ) {
          select.style.width = "100px";
        } else {
          let formText = select.options[select.selectedIndex].data.name;

          if (!formText) {
            formText = select.options[select.selectedIndex].innerHTML;
          }

          select.style.width = 10 + formText.length * 8 + "px";
        }
      },
      updatePartnerGroupSelect: function () {
        const view = CONTENT.CUSTOMER;
        const activeToggle = document.querySelector(
          `#${view.css_id} .filter .partnerGroup .activeFlag input`
        );

        const query = !activeToggle.checked
          ? null
          : {
              where: {
                active: true,
              },
            };

        restCollection.partnerGroup.find(query).then((partnerGroups) => {
          partnerGroups = partnerGroups.sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          const options = partnerGroups.map((pg) => {
            const option = document.createElement("option");
            option.textContent = pg.name;
            option.data = pg;
            return option;
          });
          const pgSelect = document.querySelector(
            `#${view.css_id} .filter .partnerGroup select`
          );
          const locationSelect = document.querySelector(
            `#${view.css_id} .filter .location select`
          );
          const employeeSelect = document.querySelector(
            `#${view.css_id} .filter .employee select`
          );
          const formSelect = document.querySelector(
            `#${view.css_id} .filter .form select`
          );
          const partnerSelect = document.querySelector(
            `#${view.css_id} .filter .partner select`
          );
          view.functions.clearFilterSelect(pgSelect);
          options.map((o) => pgSelect.appendChild(o));

          view.functions.updateSelectWidth(pgSelect, "Bitte wählen");
          view.functions.updateSelectWidth(partnerSelect, "Bitte wählen");
          view.functions.updateSelectWidth(formSelect, "Bitte wählen");
          view.functions.updateSelectWidth(locationSelect, "Alle");
          view.functions.updateSelectWidth(employeeSelect, "Alle");
        });
      },
      updatePartnerSelect: function () {
        const view = CONTENT.CUSTOMER;

        const partnerGroupSelect = document.querySelector(
          `#${view.css_id} .filter .partnerGroup select`
        );
        let partnerGroupID;

        if (
          partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data &&
          partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data.id
        ) {
          partnerGroupID =
            partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data
              .id;
        }

        if (!partnerGroupID) {
          return;
        }

        const partnerActiveToggle = document.querySelector(
          `#${view.css_id} .filter .partner .activeFlag input`
        );
        const partnerQuery = {
          partnerGroup: partnerGroupID,
        };
        if (partnerActiveToggle.checked) partnerQuery.active = true;

        const activeForm = document.querySelector(
          `#${view.css_id} .filter .active input`
        );
        activeForm.disabled = true;

        restCollection.partner
          .find({
            where: partnerQuery,
          })
          .then((partners) => {
            partners = partners.sort((a, b) => a.name.localeCompare(b.name));

            const options = partners.map((p) => {
              const option = document.createElement("option");
              option.textContent = p.name;
              option.data = p;
              return option;
            });

            const select = document.querySelector(
              `#${view.css_id} .filter .partner select`
            );
            view.functions.clearFilterSelect(select);
            options.map((o) => select.appendChild(o));

            const selectLocation = document.querySelector(
              `#${view.css_id} .filter .location select`
            );
            view.functions.clearFilterSelect(selectLocation);
            const selectEmployee = document.querySelector(
              `#${view.css_id} .filter .employee select`
            );
            view.functions.clearFilterSelect(selectEmployee);
            const selectForm = document.querySelector(
              `#${view.css_id} .filter .form select`
            );
            view.functions.clearFilterSelect(selectForm);

            const partnerSelect = document.querySelector(
              `#${view.css_id} .filter .partner select`
            );
            view.functions.updateSelectWidth(partnerSelect, "Bitte wählen");

            const formSelect = document.querySelector(
              `#${view.css_id} .filter .form select`
            );
            view.functions.updateSelectWidth(formSelect, "Bitte wählen");
          });
        // -- set export buttons to disabled --
        const exportpdfButton = document.querySelector(
          "#customer .export button.pdf"
        );
        const exportpdfcustomButton = document.querySelector(
          "#customer .export button.pdfcustom"
        );
        const exportpdfcustomButtonSP = document.querySelector(
          "#customer .export button.pdfcustomsp"
        );
        const exportButton = document.querySelector(
          "#customer .export button.ok"
        );
        const exportExcelButton = document.querySelector(
          "#customer .export button.excel"
        );
        const exportXMLButton = document.querySelector(
          "#customer .export button.xml"
        );
        const completeExportButton = document.querySelector(
          "#customer .export button.complete-button"
        );
        exportpdfButton.disabled = true;
        exportButton.disabled = true;
        exportpdfcustomButton.disabled = true;
        exportpdfcustomButtonSP.disabled = true;
        exportXMLButton.disabled = true;
        completeExportButton.disabled = true;
        exportExcelButton.disabled = true;
      },
    },
    init: function (data) {
      const view = CONTENT.CUSTOMER;
      //set labels
      const labels = [
        "location",
        "partnerGroup",
        "form",
        "employee",
        "startDate",
        "endDate",
        "text",
        "partner",
        "print-epaper",
      ];
      let labelItem;
      for (let i = 0; i < labels.length; i++) {
        labelItem = document.querySelector(
          `#customer .filter .${labels[i]} label`
        );
        labelItem.innerHTML = lng.get(labels[i]);
      }

      labelItem = document.querySelector(
        `#customer .export .formExportCsv label`
      );
      labelItem.innerHTML = lng.get(labelItem.innerHTML);
      labelItem = document.querySelector(
        `#customer .export .formExportPdf label`
      );
      labelItem.innerHTML = lng.get(labelItem.innerHTML);
      labelItem = document.querySelector(
        `#customer .export .formExportXml label`
      );
      labelItem.innerHTML = lng.get(labelItem.innerHTML);

      const tr = document.querySelector(`#customer .found thead tr`);
      tr.children[0].textContent = lng.get(tr.children[0].textContent);
      tr.children[1].innerHTML = `<label><input type="checkbox" name="exportAll" checked /> ${lng.get(
        tr.children[1].textContent
      )}</label>`;
      tr.children[2].textContent = lng.get(tr.children[2].textContent);
      tr.children[3].textContent = lng.get(tr.children[3].textContent);
      tr.children[4].textContent = lng.get(tr.children[4].textContent);
      tr.children[5].textContent = lng.get(tr.children[5].textContent);
      tr.children[6].textContent = lng.get(tr.children[6].textContent);
      tr.children[7].textContent = lng.get(tr.children[7].textContent);

      let allSortingLabels = document.querySelectorAll("#customer .sorting");
      allSortingLabels = Array.from(allSortingLabels);
      allSortingLabels.forEach((label) => {
        label.insertAdjacentHTML(
          "beforeend",
          '<i class="material-icons sorting-icon default">code</i>'
        );
      });

      const printCheckbox = document.querySelector(
        "#customer .filter .print-epaper .print"
      );
      const epaperCheckbox = document.querySelector(
        "#customer .filter .print-epaper .epaper"
      );
      const withoutCheckbox = document.querySelector(
        "#customer .filter .print-epaper .without-selection"
      );

      function handlePrintEpaperCheckbox(checkbox) {
        if (checkbox.checked) {
          withoutCheckbox.checked = false;
          withoutCheckbox.disabled = true;
        } else {
          withoutCheckbox.disabled = false;
        }
      }

      printCheckbox.addEventListener("change", () => {
        handlePrintEpaperCheckbox(printCheckbox);
      });

      epaperCheckbox.addEventListener("change", () => {
        handlePrintEpaperCheckbox(epaperCheckbox);
      });

      withoutCheckbox.addEventListener("change", () => {
        if (withoutCheckbox.checked) {
          epaperCheckbox.checked = false;
          printCheckbox.checked = false;
          epaperCheckbox.disabled = true;
          printCheckbox.disabled = true;
        } else {
          epaperCheckbox.disabled = false;
          printCheckbox.disabled = false;
        }
      });

      view.functions.updatePartnerGroupSelect();
      const fpLocale = {
        weekdays: {
          shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          longhand: [
            "Sonntag",
            "Montag",
            "Dienstag",
            "Mittwoch",
            "Donnerstag",
            "Freitag",
            "Samstag",
          ],
        },
        months: {
          shorthand: [
            "Jan",
            "Feb",
            "Mär",
            "Apr",
            "Mai",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Okt",
            "Nov",
            "Dez",
          ],
          longhand: [
            "Januar",
            "Februar",
            "März",
            "April",
            "Mai",
            "Juni",
            "Juli",
            "August",
            "September",
            "Oktober",
            "November",
            "Dezember",
          ],
        },
        firstDayOfWeek: 1,
        weekAbbreviation: "KW",
        rangeSeparator: " bis ",
        scrollTitle: "Zum Ändern scrollen",
        toggleTitle: "Zum Umschalten klicken",
      };

      const startDate = document.querySelector(
        `#${view.css_id} .filter .startDate input`
      );
      const endDate = document.querySelector(
        `#${view.css_id} .filter .endDate input`
      );

      new Flatpickr(startDate, {
        locale: fpLocale,
      });
      new Flatpickr(endDate, {
        locale: fpLocale,
      });
    },
    close: function () {
      /*var view = CONTENT.CUSTOMER;
             view.data.restView.destroy();*/
    },
    events: [
      {
        source: "#customer .filter .partnerGroup .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          view.functions.updatePartnerGroupSelect();
        },
      },
      {
        source: "#customer .filter .partnerGroup select",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const partnerGroupSelect = document.querySelector(
            `#${view.css_id} .filter .partnerGroup select`
          );
          view.functions.updateSelectWidth(partnerGroupSelect, "Bitte wählen");
          view.functions.updatePartnerSelect();
        },
      },
      {
        source: "#customer .filter .partner .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          view.functions.updatePartnerSelect();
        },
      },
      {
        source: "#customer .filter .partner .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          view.functions.updatePartnerSelect();
        },
      },
      {
        source: "#customer .filter .location select",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const select = document.querySelector(
            `#${view.css_id} .filter .location select`
          );
          view.functions.updateSelectWidth(select, "Alle");
        },
      },
      {
        source: "#customer .filter .location .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const partnerSelect = document.querySelector(
            `#${view.css_id} .filter .partner select`
          );
          const locationActiveToggle = document.querySelector(
            `#${view.css_id} .filter .location .activeFlag input`
          );
          let partnerID;

          if (
            partnerSelect.options[partnerSelect.selectedIndex].data &&
            partnerSelect.options[partnerSelect.selectedIndex].data.id
          ) {
            partnerID =
              partnerSelect.options[partnerSelect.selectedIndex].data.id;
          }

          if (!partnerID) {
            return;
          }
          // reload locations
          restCollection.locationPartner
            .find({
              where: { partner: partnerID },
              populate: "location",
            })
            .then((locationPartners) => {
              const options = [];

              if (locationActiveToggle.checked) {
                locationPartners = locationPartners.filter(
                  (lp) => lp.active === true
                );
              }

              locationPartners = locationPartners.sort((a, b) =>
                a.location.name.localeCompare(b.location.name)
              );

              locationPartners.map((lp) => {
                const option = document.createElement("option");

                if (lp.location.adress) {
                  option.textContent =
                    lp.location.name + " (" + lp.location.adress + ")";
                } else {
                  option.textContent = lp.location.name;
                }

                option.data = lp;
                options.push(option);
              });
              const select = document.querySelector(
                `#${view.css_id} .filter .location select`
              );
              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
              });

              view.functions.updateSelectWidth(select, "Alle");
            });
        },
      },
      {
        source: "#customer .filter .employee .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const partnerSelect = document.querySelector(
            `#${view.css_id} .filter .partner select`
          );
          const employeeActiveToggle = document.querySelector(
            `#${view.css_id} .filter .employee .activeFlag input`
          );
          let partnerID;

          if (
            partnerSelect.options[partnerSelect.selectedIndex].data &&
            partnerSelect.options[partnerSelect.selectedIndex].data.id
          ) {
            partnerID =
              partnerSelect.options[partnerSelect.selectedIndex].data.id;
          }

          if (!partnerID) {
            return;
          }
          //load employees
          restCollection.employeePartner
            .find({
              where: { partner: partnerID },
              populate: "employee",
            })
            .then((employeePartners) => {
              if (employeeActiveToggle.checked) {
                employeePartners = employeePartners.filter(
                  (ep) => ep.active === true
                );
              }

              employeePartners = employeePartners.sort((a, b) =>
                a.employee.name.localeCompare(b.employee.name)
              );

              const options = [];
              employeePartners.map((ep) => {
                const option = document.createElement("option");
                option.textContent = ep.employee.name;
                option.data = ep;
                options.push(option);
              });
              const select = document.querySelector(
                `#${view.css_id} .filter .employee select`
              );
              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
              });

              view.functions.updateSelectWidth(select, "Alle");
            });
        },
      },
      {
        source: "#customer .filter .employee select",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const select = document.querySelector(
            `#${view.css_id} .filter .employee select`
          );
          view.functions.updateSelectWidth(select, "Alle");
        },
      },
      {
        source: "#customer .filter .partner select",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const partnerID = this.options[this.selectedIndex].data.id;
          const activeForm = document.querySelector(
            `#${view.css_id} .filter .active input`
          );
          activeForm.disabled = false;

          const partnerSelect = document.querySelector(
            `#${view.css_id} .filter .partner select`
          );
          view.functions.updateSelectWidth(partnerSelect, "Bitte wählen");

          //load forms
          restCollection.formPartner
            .find({
              where: { partner: partnerID },
              populate: "form",
            })
            .then((formPartnerss) => {
              const options = [];
              const forms = [];
              formPartnerss
                .filter((fp) => fp.form && fp.form.productive)
                .forEach((fp) => {
                  const option = document.createElement("option");
                  option.textContent = fp.form.name + " v" + fp.form.version;
                  option.data = fp;
                  if (!activeForm.checked) {
                    options.push(option);
                    forms.push(fp.form);
                  } else if (activeForm.checked && fp.form.active) {
                    options.push(option);
                    forms.push(fp.form);
                  }
                });
              view.data.forms = forms;
              const select = document.querySelector(
                `#${view.css_id} .filter .form select`
              );

              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
              });

              view.functions.updateSelectWidth(select, "Bitte wählen");
            });

          //load locations
          restCollection.locationPartner
            .find({
              where: { partner: partnerID },
              populate: "location",
            })
            .then((locationPartners) => {
              const options = [];
              const locationActiveToggle = document.querySelector(
                `#${view.css_id} .filter .location .activeFlag input`
              );

              locationPartners = locationPartners.sort((a, b) =>
                a.location.name.localeCompare(b.location.name)
              );

              locationPartners.map((lp) => {
                if (locationActiveToggle.checked && !lp.active) {
                  return;
                }

                const option = document.createElement("option");

                if (lp.location.adress) {
                  option.textContent =
                    lp.location.name + " (" + lp.location.adress + ")";
                } else {
                  option.textContent = lp.location.name;
                }

                option.data = lp;
                options.push(option);
              });
              const select = document.querySelector(
                `#${view.css_id} .filter .location select`
              );
              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
              });

              view.functions.updateSelectWidth(select, "Alle");
            });

          //load employees
          restCollection.employeePartner
            .find({
              where: { partner: partnerID },
              populate: "employee",
            })
            .then((employeePartners) => {
              employeePartners = employeePartners.sort((a, b) =>
                a.employee.name.localeCompare(b.employee.name)
              );

              const employeeActiveToggle = document.querySelector(
                `#${view.css_id} .filter .employee .activeFlag input`
              );
              const options = [];
              employeePartners.map((ep) => {
                if (employeeActiveToggle.checked && !ep.active) {
                  return;
                }

                const option = document.createElement("option");
                option.textContent = ep.employee.name;
                option.data = ep;
                options.push(option);
              });
              const select = document.querySelector(
                `#${view.css_id} .filter .employee select`
              );
              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
              });

              view.functions.updateSelectWidth(select, "Alle");
            });
          // -- set export buttons to disabled --
          const exportpdfButton = document.querySelector(
            "#customer .export button.pdf"
          );
          const exportpdfcustomButton = document.querySelector(
            "#customer .export button.pdfcustom"
          );
          const exportpdfcustomButtonSP = document.querySelector(
            "#customer .export button.pdfcustomsp"
          );
          const exportButton = document.querySelector(
            "#customer .export button.ok"
          );
          const exportExcelButton = document.querySelector(
            "#customer .export button.excel"
          );
          const exportXMLButton = document.querySelector(
            "#customer .export button.xml"
          );
          const completeExportButton = document.querySelector(
            "#customer .export button.complete-button"
          );
          exportpdfButton.disabled = true;
          exportButton.disabled = true;
          exportpdfcustomButton.disabled = true;
          exportpdfcustomButtonSP.disabled = true;
          exportXMLButton.disabled = true;
          completeExportButton.disabled = true;
          exportExcelButton.disabled = true;
        },
      },
      {
        source: "#customer .filter .active input",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const selectedPartner = document.querySelector(
            `#${view.css_id} .filter .partner select`
          );
          let partnerID;

          if (
            selectedPartner.options[selectedPartner.selectedIndex].data &&
            selectedPartner.options[selectedPartner.selectedIndex].data.id
          ) {
            partnerID =
              selectedPartner.options[selectedPartner.selectedIndex].data.id;
          }

          if (!partnerID) {
            return;
          }

          const activeForm = document.querySelector(
            `#${view.css_id} .filter .active input`
          );
          //load forms
          restCollection.formPartner
            .find({
              where: { partner: partnerID },
              populate: "form",
            })
            .then((formPartnerss) => {
              const options = [];
              formPartnerss.map((fp) => {
                if (fp.form) {
                  if (fp.form.productive) {
                    const option = document.createElement("option");
                    option.textContent = fp.form.name + " v" + fp.form.version;
                    option.data = fp;
                    if (!activeForm.checked) {
                      options.push(option);
                    } else if (activeForm.checked && fp.form.active) {
                      options.push(option);
                    }
                  }
                }
              });
              const select = document.querySelector(
                `#${view.css_id} .filter .form select`
              );
              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
              });

              view.functions.updateSelectWidth(select, "Bitte wählen");
            });
          // -- set export buttons to disabled --
          const exportpdfButton = document.querySelector(
            "#customer .export button.pdf"
          );
          const exportpdfcustomButton = document.querySelector(
            "#customer .export button.pdfcustom"
          );
          const exportpdfcustomButtonSP = document.querySelector(
            "#customer .export button.pdfcustomsp"
          );
          const exportButton = document.querySelector(
            "#customer .export button.ok"
          );
          const exportExcelButton = document.querySelector(
            "#customer .export button.excel"
          );
          const exportXMLButton = document.querySelector(
            "#customer .export button.xml"
          );
          const completeExportButton = document.querySelector(
            "#customer .export button.complete-button"
          );
          exportpdfButton.disabled = true;
          exportButton.disabled = true;
          exportExcelButton.disabled = true;
          exportpdfcustomButton.disabled = true;
          exportpdfcustomButtonSP.disabled = true;
          exportXMLButton.disabled = true;
          completeExportButton.disabled = true;
        },
      },
      {
        source: "#customer .filter .form select",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const form = this.options[this.selectedIndex].data.form;
          const formID = form.id;
          const viewNode = document.getElementById(view.css_id);

          const select = document.querySelector(
            `#${view.css_id} .filter .form select`
          );
          view.functions.updateSelectWidth(select, "Bitte wählen");

          const formSchema = JSON.parse(form.schema);
          let foundPrint = false;
          formSchema.forEach((d) => {
            if (d.type === "address" && d.meta.epaper) {
              foundPrint = true;
            }
          });

          const checkboxes = document.querySelectorAll(
            "#customer .filter .print-epaper .checkbox"
          );
          for (let i = 0; i < checkboxes.length; ++i) {
            checkboxes[i].disabled = !foundPrint;
          }

          //load formExportCsv
          restCollection.formExportCsv
            .find({
              where: { form: formID },
            })
            .then((forms) => {
              const options = [];
              forms.map((f) => {
                const option = document.createElement("option");
                option.textContent = f.name;
                option.data = f;
                options.push(option);
              });
              const select = viewNode.querySelector(
                `.export .formExportCsv select`
              );

              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
                if (select.length > 1) {
                  select.selectedIndex = 1;
                }
              });
            });
          restCollection.formExportXml
            .find({
              where: { form: formID },
            })
            .then((forms) => {
              const options = [];
              forms.map((f) => {
                const option = document.createElement("option");
                option.textContent = f.name;
                option.data = f;
                options.push(option);
              });
              const select = viewNode.querySelector(
                `.export .formExportXml select`
              );
              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
                if (select.length > 1) select.selectedIndex = 1;
              });
            });
          //load formExportPdf
          restCollection.formExportPdf
            .find({
              where: { form: formID },
            })
            .then((forms) => {
              const options = [];
              forms.map((f) => {
                const option = document.createElement("option");
                option.textContent = f.name;
                option.data = f;
                options.push(option);
              });
              const select = viewNode.querySelector(
                `.export .formExportPdf select`
              );

              select.data = null;
              requestAnimationFrame(() => {
                view.functions.clearFilterSelect(select);
                options.map((o) => select.appendChild(o));
                if (select.length > 1) {
                  select.selectedIndex = 1;
                }
              });
            });
          // -- create form filter --
          const formFilterWrapper = viewNode.querySelector(".filter-by-form");
          const old = formFilterWrapper.querySelector(".form-filter");
          if (old) formFilterWrapper.removeChild(old);

          formFilterWrapper.classList.add("filled");

          const formFilter = new FormFilter(form);
          view.data.formFilter = formFilter;
          formFilterWrapper.appendChild(formFilter.node);

          // -- set export buttons to disabled --
          const exportpdfButton = document.querySelector(
            "#customer .export button.pdf"
          );
          const exportpdfcustomButton = document.querySelector(
            "#customer .export button.pdfcustom"
          );
          const exportpdfcustomButtonSP = document.querySelector(
            "#customer .export button.pdfcustomsp"
          );
          const exportButton = document.querySelector(
            "#customer .export button.ok"
          );
          const exportExcelButton = document.querySelector(
            "#customer .export button.excel"
          );
          const exportXMLButton = document.querySelector(
            "#customer .export button.xml"
          );
          const completExportButton = document.querySelector(
            "#customer .export button.complete-button"
          );
          exportpdfButton.disabled = true;
          exportpdfcustomButtonSP.disabled = true;
          exportButton.disabled = true;
          exportpdfcustomButton.disabled = true;
          exportXMLButton.disabled = true;
          completExportButton.disabled = true;
          exportExcelButton.disabled = true;
        },
      },
      {
        source: "#customer .sorting.prename",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          const getPrenameFromForm = view.functions.getPrenameFromForm;

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return getPrenameFromForm(a.data).toLowerCase() <
                getPrenameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            } else {
              return getPrenameFromForm(a.data).toLowerCase() >
                getPrenameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            }
          });

          view.functions.renderCustomerTable(view);
        },
      },
      {
        source: "#customer .sorting.time",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return new Date(a.date) - new Date(b.date);
            } else {
              return new Date(b.date) - new Date(a.date);
            }
          });

          view.functions.renderCustomerTable(view);
        },
      },
      {
        source: "#customer .sorting.surname",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          const getSurnameFromForm = view.functions.getSurnameFromForm;

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return getSurnameFromForm(a.data).toLowerCase() <
                getSurnameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            } else {
              return getSurnameFromForm(a.data).toLowerCase() >
                getSurnameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            }
          });

          view.functions.renderCustomerTable(view);
        },
      },
      {
        source: "#customer .filter button.ok",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const selctorPrefix = `#${view.css_id} .filter`;

          const partnerSelect = document.querySelector(
            `${selctorPrefix} .partner select`
          );
          const formSelect = document.querySelector(
            `${selctorPrefix} .form select`
          );
          const locationSelect = document.querySelector(
            `${selctorPrefix} .location select`
          );
          const employeeSelect = document.querySelector(
            `${selctorPrefix} .employee select`
          );
          const startDate = document.querySelector(
            `${selctorPrefix} input[name=startDate]`
          ).value;
          let endDate = document.querySelector(
            `${selctorPrefix} input[name=endDate]`
          ).value;
          const text = document.querySelector(
            `${selctorPrefix} input[name=text]`
          ).value;

          let partner = partnerSelect.options[partnerSelect.selectedIndex].data;
          let formPartner = formSelect.options[formSelect.selectedIndex].data;
          const locationPartner =
            locationSelect.options[locationSelect.selectedIndex].data;
          const employeePartner =
            employeeSelect.options[employeeSelect.selectedIndex].data;

          if (!partner || !formPartner) {
            snackbar.show({ message: "Partner und Formular auswählen" });
            return;
          }

          view.functions.removeAllIcons();

          const query = {
            formPartner: formPartner.id,
          };
          if (locationPartner) query.locationPartner = locationPartner.id;
          if (employeePartner) query.employeePartner = employeePartner.id;

          if (startDate || endDate) {
            const dateQuery = {};
            if (startDate) dateQuery[">="] = startDate;
            if (endDate) {
              // add 1 day to include the selected day into the results
              endDate = new Date(endDate);
              endDate.setDate(endDate.getDate() + 1);
              endDate = endDate.toISOString();
              dateQuery["<="] = endDate;
            }
            query.date = dateQuery;
          }

          if (text) query.data = { contains: text };

          const formFilterQuery = view.data.formFilter.getQuery();
          if (formFilterQuery) query.formFilter = formFilterQuery;

          const table = document.querySelector(`#${view.css_id} table.found`);
          const tbody = table.querySelector("tbody");

          table.classList.add("loading");

          //remove old table content while waiting and parsing the request
          Promise.all([
            restCollection.customer
              //API populates always to 2nd level for employee and location
              .find({ where: query }),
            new Promise((resolve) => {
              tbody.innerHTML = null;
              resolve();
            }),
          ]).then((customers) => {
            // remove the download-information from the DOM
            let downloadInfo = document.querySelector(".download-info");
            if (downloadInfo && downloadInfo.parentNode) {
              downloadInfo.parentNode.removeChild(downloadInfo);
            }

            customers = customers[0]; //cause Promise.all

            if (customers.length === 0) {
              snackbar.show({
                message: "Keine Daten für die Anfrage verfügbar.",
              });
            }
            const trs = [];
            const formToHtml = view.functions.formToHtml;
            const getPrenameFromForm = view.functions.getPrenameFromForm;
            const getSurnameFromForm = view.functions.getSurnameFromForm;
            let counter = 1;

            const printCheckbox = document.querySelector(
              "#customer .filter .print-epaper .print"
            );
            const epaperCheckbox = document.querySelector(
              "#customer .filter .print-epaper .epaper"
            );
            const withoutCheckbox = document.querySelector(
              "#customer .filter .print-epaper .without-selection"
            );

            if (withoutCheckbox.checked) {
              customers = customers.filter((customer) => {
                const data = JSON.parse(customer.data);
                let found = false;
                data.forEach((d) => {
                  if (
                    d.data &&
                    d.data.epaper === false &&
                    d.data.print === false
                  ) {
                    found = true;
                  }
                });
                return found;
              });
            } else if (printCheckbox.checked && epaperCheckbox.checked) {
              customers = customers.filter((customer) => {
                const data = JSON.parse(customer.data);
                let found = false;
                data.forEach((d) => {
                  if (d.data) {
                    if (d.data.print) {
                      found = true;
                    }
                    if (d.data.epaper) {
                      found = true;
                    }
                  }
                });
                return found;
              });
            } else if (
              (printCheckbox.checked || epaperCheckbox.checked) &&
              !printCheckbox.disabled &&
              !epaperCheckbox.disabled
            ) {
              customers = customers.filter((customer) => {
                const data = JSON.parse(customer.data);
                let found = false;
                data.forEach((d) => {
                  if (d.data) {
                    if (printCheckbox.checked && d.data.print) {
                      found = true;
                    } else if (epaperCheckbox.checked && d.data.epaper) {
                      found = true;
                    }
                  }
                });
                return found;
              });
            }

            view.data.allCustomers = customers;

            customers.map((c) => {
              var tr = document.createElement("tr");
              tr.data = c;

              if (c.locationPartner) {
                tr.insertAdjacentHTML(
                  "beforeend",
                  `
                                    <td>${counter++}</td>
                                    <td><input type="checkbox" name="export" value="${
                                      c.id
                                    }" checked /></td>
                                    <td>${c.locationPartner.location.name}</td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
                );
              } else {
                tr.insertAdjacentHTML(
                  "beforeend",
                  `
                                    <td>${counter++}</td>
                                    <td><input type="checkbox" name="export" value="${
                                      c.id
                                    }" checked /></td>
                                    <td></td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
                );
              }

              tr.children[tr.children.length - 1].appendChild(
                formToHtml(c.data)
              ); //put parsed json to last td of this row
              trs.push(tr);
            });
            requestAnimationFrame(() => {
              trs.map((tr) => tbody.appendChild(tr));
              table.classList.remove("loading");

              let allSortingLabels =
                document.querySelectorAll("#customer .sorting");
              allSortingLabels = Array.from(allSortingLabels);
              allSortingLabels.forEach((label) => {
                label.insertAdjacentHTML(
                  "beforeend",
                  '<i class="material-icons sorting-icon default">code</i>'
                );
              });
            });

            //disable export if no customers found
            const exportpdfButton = document.querySelector(
              "#customer .export button.pdf"
            );
            const exportpdfcustomButton = document.querySelector(
              "#customer .export button.pdfcustom"
            );
            const exportpdfcustomButtonSP = document.querySelector(
              "#customer .export button.pdfcustomsp"
            );
            const exportButton = document.querySelector(
              "#customer .export button.ok"
            );
            const exportExcelButton = document.querySelector(
              "#customer .export button.excel"
            );
            const exportXMLButton = document.querySelector(
              "#customer .export button.xml"
            );
            const completeExportButton = document.querySelector(
              "#customer .export button.complete-button"
            );
            exportpdfButton.disabled = customers.length === 0;
            exportpdfcustomButtonSP.disabled = customers.length === 0;
            exportButton.disabled = customers.length === 0;
            exportpdfcustomButton.disabled = customers.length === 0;
            exportXMLButton.disabled = customers.length === 0;
            completeExportButton.disabled = customers.length === 0;
            exportExcelButton.disabled = customers.length === 0;
          });
        },
      },
      {
        source: "#customer input[name=exportAll]",
        event: "click",
        function: function () {
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]"
          );
          checkboxes = Array.from(checkboxes);
          checkboxes.map((c) => (c.checked = this.checked));
        },
      },
      {
        source: "#customer .export button.pdf",
        event: "click",
        function: function () {
          startPDFDownload("all", this);

          function startPDFDownload(type, button) {
            let checkboxes = document.querySelectorAll(
              "#customer .found input[name=export]:checked"
            );
            checkboxes = Array.from(checkboxes);
            const customerIds = checkboxes.map((c) => c.value);
            const view = CONTENT.CUSTOMER;
            const selectorPrefix = `#${view.css_id} .filter`;
            const formSelect = document.querySelector(
              `${selectorPrefix} .form select`
            );

            const currentForm =
              formSelect.options[formSelect.selectedIndex].data.form;
            const currentFormId = currentForm.id;
            const div = document.createElement("div");
            const allPdfs = parseInt(customerIds.length / 50, 10) + 1;
            let count = 0;
            div.classList.add("download-info");
            div.style.zIndex = 200;
            div.style.position = "absolute";
            div.style.bottom = "20px";
            div.style.right = "20px";
            div.style.width = "300px";
            div.style.height = "120px";
            div.style.borderRadius = "15px";
            div.style.padding = "10px";
            div.style.paddingTop = "30px";
            div.style.backgroundColor = "#ffffff";
            div.innerHTML = `<div style="display: flex; justify-content: space-around; width: 100%;">Heruntergeladen:  ${count}/${allPdfs}</div><div style="display: flex; justify-content: space-around; width: 100%;"><p style="width: 100px;" class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"></p></div>`;
            button.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.insertBefore(
              div,
              button.parentElement.parentElement.parentElement.parentElement
                .parentElement
            );
            const len = customerIds.length;
            downloadPDFs(0, 50);

            function downloadPDFs(start, length) {
              const xhr = Network.openXHR(
                "POST",
                restCollection.customer.endPoint + "/pdf?type=" + type,
                true
              );
              xhr.responseType = "json";
              const slicecustomerIds = customerIds.slice(start, start + length);
              xhr.i = parseInt(start / length, 10);
              xhr.onreadystatechange = function () {
                if (this.readyState !== XMLHttpRequest.DONE) return;

                if (this.status !== 200) {
                  if (this.response.error === "No Customers found") {
                    snackbar.show({
                      message:
                        "Für Ihre Auswahl wurden keine Abonnements gefunden.",
                    });
                  } else {
                    snackbar.show({ message: lng.get(this.response.error) });
                  }

                  let downloadInfo = document.querySelector(".download-info");
                  downloadInfo.parentNode.removeChild(downloadInfo);
                  return;
                }

                if (start + length < len) {
                  downloadPDFs(start + length, length);
                }

                count += 1;
                div.innerHTML = `<div style="display: flex; justify-content: space-around; width: 100%;">Heruntergeladen:  ${count}/${allPdfs}</div><div style="display: flex; justify-content: space-around; width: 100%; color: green;">Fertig!</div>`;
                if (count === allPdfs) {
                  setTimeout(function () {
                    div.parentNode.removeChild(div);
                  }, 5000);
                }
                const a = document.createElement("a");
                a.download = `${
                  currentForm.name
                }_${new Date().toLocaleDateString()}_${count}.pdf`;
                let base64 = this.response.pdf.replace(
                  "data:application/pdf;base64,",
                  ""
                );
                let blob = b64toBlob(base64, "application/pdf");
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.style.display = "none";
                button.parentNode.insertBefore(a, button);
                a.click();
                a.parentNode.removeChild(a);
              };
              xhr.send(
                JSON.stringify({
                  formid: currentFormId,
                  ids: slicecustomerIds,
                })
              );
            }
          }
        },
      },
      {
        source: "#customer .export button.pdfcustom",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const button = this;
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]:checked"
          );
          checkboxes = Array.from(checkboxes);
          const customerIds = checkboxes.map((c) => c.value);
          const formExportSelect = document.querySelector(
            "#customer .export .formExportPdf select"
          );
          const formExportSelection =
            formExportSelect.options[formExportSelect.selectedIndex];
          if (!formExportSelection.data || !formExportSelection.data.id) {
            snackbar.show({ message: "PDF Vorlage auswählen" });
            return;
          }
          const formExportID = formExportSelection.data.id;

          const selctorPrefix = `#${view.css_id} .filter`;
          const formSelect = document.querySelector(
            `${selctorPrefix} .form select`
          );
          const maxDownloads = 25;
          const currentForm =
            formSelect.options[formSelect.selectedIndex].data.form;
          const div = document.createElement("div");
          const allPdfs = parseInt(customerIds.length / maxDownloads, 10) + 1;

          let count = 0;
          div.style.position = "absolute";
          div.style.zIndex = "9999999";
          div.style.bottom = "20px";
          div.style.right = "20px";
          div.style.width = "300px";
          div.style.height = "120px";
          div.style.borderRadius = "15px";
          div.style.padding = "10px";
          div.style.paddingTop = "30px";
          div.style.backgroundColor = "#ffffff";
          div.innerHTML = `<div style="display: flex; justify-content: space-around; width: 100%;">Heruntergeladen:  ${count}/${allPdfs}</div><div style="display: flex; justify-content: space-around; width: 100%;"><p style="width: 100px;" class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"></p></div>`;
          button.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.insertBefore(
            div,
            button.parentElement.parentElement.parentElement.parentElement
              .parentElement
          );

          let i = 0;
          downloadPDFs(0, maxDownloads, customerIds.length);

          function downloadPDFs(start, length, pdfCount) {
            const xhr = Network.openXHR(
              "POST",
              restCollection.customer.endPoint + "/pdfcustom",
              true
            );
            xhr.responseType = "json";
            const slicecustomerIds = customerIds.slice(start, start + length);
            xhr.i = parseInt(i / maxDownloads, 10);
            xhr.onreadystatechange = function () {
              if (this.readyState !== XMLHttpRequest.DONE) return;

              if (this.status !== 200) {
                snackbar.show({ message: lng.get(xhr.status) });

                setTimeout(function () {
                  div.parentNode.removeChild(div);
                }, 5000);

                return;
              }

              if (start + length < pdfCount) {
                downloadPDFs(start + length, length, customerIds.length);
              }

              count += 1;
              div.innerHTML = `<div style="display: flex; justify-content: space-around; width: 100%;">Heruntergeladen:  ${count}/${allPdfs}</div><div style="display: flex; justify-content: space-around; width: 100%; color: green;">Fertig!</div>`;
              if (count === allPdfs) {
                setTimeout(function () {
                  div.parentNode.removeChild(div);
                }, 5000);
              }

              const block = this.response.pdf.split(";");
              const realData = block[1].split(",")[1];
              const base64str = realData;
              const binary = atob(base64str.replace(/\s/g, ""));
              const len = binary.length;
              const buffer = new ArrayBuffer(len);
              const view = new Uint8Array(buffer);
              for (let i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
              }

              const blob = new Blob([view], { type: "application/pdf" });
              const url = URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.download = `${
                currentForm.name
              }_${new Date().toLocaleDateString()}_${count}.pdf`;
              a.href = url;
              a.style.display = "none";
              button.parentNode.insertBefore(a, button);
              a.click();
              a.parentNode.removeChild(a);
            };
            xhr.send(
              JSON.stringify({
                formExportPdf: formExportID,
                ids: slicecustomerIds,
              })
            );
          }
        },
      },
      {
        source: "#customer .export button.pdfcustomsp",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER;
          const button = this;
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]:checked"
          );
          checkboxes = Array.from(checkboxes);
          const customerIds = checkboxes.map((c) => c.value);
          const formExportSelect = document.querySelector(
            "#customer .export .formExportPdf select"
          );
          const formExportSelection =
            formExportSelect.options[formExportSelect.selectedIndex];
          if (!formExportSelection.data || !formExportSelection.data.id) {
            snackbar.show({ message: "PDF Vorlage auswählen" });
            return;
          }
          const formExportID = formExportSelection.data.id;

          const selctorPrefix = `#${view.css_id} .filter`;
          const formSelect = document.querySelector(
            `${selctorPrefix} .form select`
          );

          const currentForm =
            formSelect.options[formSelect.selectedIndex].data.form;
          const div = document.createElement("div");
          const allPdfs = parseInt(customerIds.length / 50, 10) + 1;
          let count = 0;
          div.style.position = "absolute";
          div.style.bottom = "20px";
          div.style.right = "20px";
          div.style.width = "300px";
          div.style.height = "120px";
          div.style.borderRadius = "15px";
          div.style.padding = "10px";
          div.style.paddingTop = "30px";
          div.style.backgroundColor = "#ffffff";
          div.style.zIndex = "1000";
          div.innerHTML = `<div style="display: flex; justify-content: space-around; width: 100%;">Heruntergeladen:  ${count}/${allPdfs}</div><div style="display: flex; justify-content: space-around; width: 100%;"><p style="width: 100px;" class="mdl-spinner mdl-js-spinner mdl-spinner--single-color is-active"></p></div>`;
          button.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.insertBefore(
            div,
            button.parentElement.parentElement.parentElement.parentElement
              .parentElement
          );

          function downloadZipFile(i) {
            const xhr = Network.openXHR(
              "POST",
              restCollection.customer.endPoint + "/pdfcustomsp"
            );
            xhr.responseType = "json";
            const slicecustomerIds = customerIds.slice(i, i + 50);
            xhr.i = parseInt(i / 50, 10);
            xhr.onreadystatechange = function () {
              if (this.readyState !== XMLHttpRequest.DONE) return;

              if (this.status !== 200) {
                snackbar.show({ message: lng.get(this.status) });
                return;
              }
              count += 1;
              div.innerHTML = `<div style="display: flex; justify-content: space-around; width: 100%;">Heruntergeladen:  ${count}/${allPdfs}</div><div style="display: flex; justify-content: space-around; width: 100%; color: green;">Fertig!</div>`;
              if (count === allPdfs) {
                setTimeout(function () {
                  div.parentNode.removeChild(div);
                }, 5000);
              }
              const a = document.createElement("a");
              a.download = `${
                currentForm.name
              }_${new Date().toLocaleDateString()}_${this.i}.zip`;
              //a.href = "data:application/zip;base64," + this.response.zip;
              a.style.display = "none";
              let blob = b64toBlob(this.response.zip, "application/zip");
              a.href = window.URL.createObjectURL(blob);
              if (navigator.userAgent.toLowerCase().indexOf("chrome") > -1)
                a.target = "_blank";
              button.parentNode.insertBefore(a, button);
              a.click();
              //a.parentNode.removeChild(a);
              if (i + 50 < customerIds.length) {
                downloadZipFile(i + 50);
              }
            };
            xhr.send(
              JSON.stringify({
                formExportPdf: formExportID,
                ids: slicecustomerIds,
              })
            );
          }

          downloadZipFile(0);
        },
      },
      {
        source: "#customer .export button.excel",
        event: "click",
        function: function () {
          const button = this;
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]:checked"
          );
          const partnerSelect = document.querySelector(
            "#customer .filter .partner select"
          );
          const partner =
            partnerSelect.options[partnerSelect.selectedIndex].data;
          const formSelect = document.querySelector(
            "#customer .filter .form select"
          );
          const form = formSelect.options[formSelect.selectedIndex].data.form;
          let exportName = `export_${new Date().toISOString()}.xlsx`;
          if (partner.exportNameing) {
            let nameing = partner.exportNameing.replace("$firstname$", "");
            nameing = nameing.replace("$lastname$", "");
            nameing = nameing.replace("$city$", "");
            nameing = nameing.replace(/\s/g, "");

            if (nameing.length > 0) {
              exportName = partner.exportNameing;
              exportName = exportName
                .split("$date$")
                .join(moment(new Date()).format("DDMMYY"));
              exportName = exportName
                .split("$datelong$")
                .join(moment(new Date()).format("DDMMYYYY"));
              exportName = exportName.split("$form$").join(form.name);
              exportName = exportName.split("$name$").join(partner.name);
              exportName += ".xlsx";
            }
          }

          checkboxes = Array.from(checkboxes);
          const customerIds = checkboxes.map((c) => c.value);
          const formExportSelect = document.querySelector(
            "#customer .export .formExportCsv select"
          );
          const formExportSelection =
            formExportSelect.options[formExportSelect.selectedIndex];
          if (!formExportSelection.data || !formExportSelection.data.id) {
            snackbar.show({ message: "Bitte Vorlage auswählen" });
            return;
          }
          const formExportID = formExportSelection.data.id;

          const xhr = Network.openXHR(
            "POST",
            `${restCollection.customer.endPoint}/excel`
          );
          xhr.responseType = "blob";
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (xhr.status !== 200) {
              snackbar.show({ message: lng.get(xhr.status) });
              return;
            }

            // Excel-Export !!!
            const charset =
              formExportSelection.data.csvEncoding === "ansi"
                ? ";charset=windows-1252;"
                : "";
            const blob = new Blob([xhr.response], {
              type: "application/octet-stream" + charset,
            });
            const exportUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");

            a.href = exportUrl;
            a.download = exportName;
            a.style.display = "none";
            button.parentNode.insertBefore(a, button);
            a.click();
            a.parentNode.removeChild(a);
            window.URL.revokeObjectURL(exportUrl);
          };
          xhr.send(
            JSON.stringify({
              formExportCsv: formExportID,
              ids: customerIds,
            })
          );
        },
      },
      {
        source: "#customer .export button.ok",
        event: "click",
        function: function () {
          const button = this;
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]:checked"
          );
          const partnerSelect = document.querySelector(
            "#customer .filter .partner select"
          );
          const partner =
            partnerSelect.options[partnerSelect.selectedIndex].data;
          const formSelect = document.querySelector(
            "#customer .filter .form select"
          );
          const form = formSelect.options[formSelect.selectedIndex].data.form;
          let exportName = `export_${new Date().toISOString()}.csv`;
          if (partner.exportNameing) {
            let nameing = partner.exportNameing.replace("$firstname$", "");
            nameing = nameing.replace("$lastname$", "");
            nameing = nameing.replace("$city$", "");
            nameing = nameing.replace(/\s/g, "");

            if (nameing.length > 0) {
              exportName = partner.exportNameing;
              exportName = exportName
                .split("$date$")
                .join(moment(new Date()).format("DDMMYY"));
              exportName = exportName
                .split("$datelong$")
                .join(moment(new Date()).format("DDMMYYYY"));
              exportName = exportName.split("$form$").join(form.name);
              exportName = exportName.split("$name$").join(partner.name);
              exportName += ".csv";
            }
          }

          checkboxes = Array.from(checkboxes);
          const customerIds = checkboxes.map((c) => c.value);

          const formExportSelect = document.querySelector(
            "#customer .export .formExportCsv select"
          );
          const formExportSelection =
            formExportSelect.options[formExportSelect.selectedIndex];
          if (!formExportSelection.data || !formExportSelection.data.id) {
            snackbar.show({ message: "CSV Vorlage auswählen" });
            return;
          }

          const formExportID = formExportSelection.data.id;
          const xhr = Network.openXHR(
            "POST",
            `${restCollection.customer.endPoint}/csv`
          );
          xhr.responseType = "blob";
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (xhr.status !== 200) {
              snackbar.show({ message: lng.get(xhr.status) });
              return;
            }

            function exportAsCSV() {
              const blob = new Blob(["\ufeff", xhr.response], {
                type: "text/csv",
              });
              const exportUrl = window.URL.createObjectURL(blob);

              const a = document.createElement("a");
              a.href = exportUrl;
              a.download = exportName;
              a.style.display = "none";
              button.parentNode.insertBefore(a, button);
              a.click();
              a.parentNode.removeChild(a);
              window.URL.revokeObjectURL(exportUrl);
            }

            // CSV-Export !!!
            if (formExportSelection.data.csvEncoding === "ansi") {
              const textEncoder = new CustomTextEncoder("windows-1252", {
                NONSTANDARD_allowLegacyEncoding: true,
              });

              const reader = new FileReader();
              reader.onload = function () {
                try {
                  let encoded = textEncoder.encode(reader.result);
                  const blob = new Blob([encoded.buffer], {
                    type: "text/csv;charset=windows-1252;",
                  });
                  saveAs(blob, exportName);
                } catch (err) {
                  exportAsCSV();
                }
              };
              reader.readAsText(xhr.response);
            } else {
              exportAsCSV();
            }
          };
          xhr.send(
            JSON.stringify({
              formExportCsv: formExportID,
              ids: customerIds,
            })
          );
        },
      },
      {
        source: "#customer .export button.xml",
        event: "click",
        function: function () {
          const button = this;
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]:checked"
          );
          const partnerSelect = document.querySelector(
            "#customer .filter .partner select"
          );
          const partner =
            partnerSelect.options[partnerSelect.selectedIndex].data;
          const formSelect = document.querySelector(
            "#customer .filter .form select"
          );
          const form = formSelect.options[formSelect.selectedIndex].data.form;
          let exportName = `export_${new Date().toISOString()}.xml`;
          if (partner.exportNameing) {
            let nameing = partner.exportNameing.replace("$firstname$", "");
            nameing = nameing.replace("$lastname$", "");
            nameing = nameing.replace("$city$", "");
            nameing = nameing.replace(/\s/g, "");

            if (nameing.length > 0) {
              exportName = partner.exportNameing;
              exportName = exportName
                .split("$date$")
                .join(moment(new Date()).format("DDMMYY"));
              exportName = exportName
                .split("$datelong$")
                .join(moment(new Date()).format("DDMMYYYY"));
              exportName = exportName.split("$form$").join(form.name);
              exportName = exportName.split("$name$").join(partner.name);
              exportName += ".xml";
            }
          }
          checkboxes = Array.from(checkboxes);
          const customerIds = checkboxes.map((c) => c.value);

          const formExportSelect = document.querySelector(
            "#customer .export .formExportXml select"
          );
          const formExportSelection =
            formExportSelect.options[formExportSelect.selectedIndex];
          if (!formExportSelection.data || !formExportSelection.data.id) {
            snackbar.show({ message: "XML Vorlage auswählen" });
            return;
          }
          const formExportID = formExportSelection.data.id;

          const xhr = Network.openXHR(
            "POST",
            restCollection.customer.endPoint + "/xml"
          );
          xhr.responseType = "blob";
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (xhr.status !== 200) {
              snackbar.show({ message: lng.get(xhr.status) });
              return;
            }
            const blob = new Blob(["\ufeff", xhr.response], {
              type: "text/xml",
            });
            const exportUrl = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = exportUrl;
            a.download = exportName;
            a.style.display = "none";
            button.parentNode.insertBefore(a, button);
            a.click();
            a.parentNode.removeChild(a);
            window.URL.revokeObjectURL(exportUrl);
          };
          xhr.send(
            JSON.stringify({
              formExportXml: formExportID,
              ids: customerIds,
            })
          );
        },
      },
      {
        source: "#customer .export button.complete-button",
        event: "click",
        function: function () {
          const button = this;
          let checkboxes = document.querySelectorAll(
            "#customer .found input[name=export]:checked"
          );
          const partnerSelect = document.querySelector(
            "#customer .filter .partner select"
          );
          const partner =
            partnerSelect.options[partnerSelect.selectedIndex].data;
          const formSelect = document.querySelector(
            "#customer .filter .form select"
          );
          const form = formSelect.options[formSelect.selectedIndex].data.form;
          let exportName = `export_${new Date().toISOString()}.zip`;
          if (partner.exportNameing) {
            exportName = partner.exportNameing;
            exportName = exportName
              .split("$date$")
              .join(moment(new Date()).format("DDMMYY"));
            exportName = exportName
              .split("$datelong$")
              .join(moment(new Date()).format("DDMMYYYY"));
            exportName = exportName.split("$form$").join(form.name);
            exportName = exportName.split("$name$").join(partner.name);
            exportName += ".zip";
          }
          checkboxes = Array.from(checkboxes);
          const customerIds = checkboxes.map((c) => c.value);
          const formExportSelectXML = document.querySelector(
            "#customer .export .formExportXml select"
          );
          const formExportSelectionXML =
            formExportSelectXML.options[formExportSelectXML.selectedIndex];
          const formExportSelectCSV = document.querySelector(
            "#customer .export .formExportCsv select"
          );
          const formExportSelectionCSV =
            formExportSelectCSV.options[formExportSelectCSV.selectedIndex];
          const formExportSelectPDF = document.querySelector(
            "#customer .export .formExportPdf select"
          );
          const formExportSelectionPDF =
            formExportSelectPDF.options[formExportSelectPDF.selectedIndex];
          const currentForm =
            formSelect.options[formSelect.selectedIndex].data.form;

          let formExportIdPDF, formExportIdCSV, formExportIdXML;

          if (formExportSelectionPDF && formExportSelectionPDF.data)
            formExportIdPDF = formExportSelectionPDF.data.id;
          if (formExportSelectionCSV && formExportSelectionCSV.data)
            formExportIdCSV = formExportSelectionCSV.data.id;
          if (formExportSelectionXML && formExportSelectionXML.data)
            formExportIdXML = formExportSelectionXML.data.id;

          const data = {
            pdf: formExportIdPDF,
            csv: formExportIdCSV,
            xml: formExportIdXML,
          };

          const xhr = Network.openXHR(
            "POST",
            restCollection.customer.endPoint + "/completeExport"
          );
          xhr.responseType = "blob";
          xhr.onreadystatechange = function () {
            if (xhr.readyState !== XMLHttpRequest.DONE) return;

            if (xhr.status !== 200) {
              snackbar.show({ message: lng.get(xhr.status) });
              return;
            }
            let exportName = `${
              currentForm.name
            }_${new Date().toLocaleDateString()}.zip`;
            let a = document.createElement("a");
            a.href = window.URL.createObjectURL(xhr.response);
            a.download = exportName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
          };
          xhr.send(
            JSON.stringify({
              data: data,
              ids: customerIds,
            })
          );
        },
      },
      {
        source: "#customer .found button.sign",
        event: "click",
        function: function () {
          const td = this.parentNode;

          //find table
          let table = this;
          do {
            table = table.parentNode;
          } while (
            !table.classList.contains("dataset") &&
            table !== document.body
          );

          //get sign from table

          if (!table.signs) {
            console.error("signs not found on table");
            return;
          }

          const signIndex = parseInt(this.dataset.signindex, 10);
          let path = table.signs[signIndex];

          if (!path) {
            console.error("sign not found in array");
            return;
          }

          const canvas = createSign(path);

          requestAnimationFrame(() => {
            td.removeChild(this);
            td.appendChild(canvas);
          });
        },
      },
    ],
  },
  CUSTOMER_TODAY: {
    css_id: "customer_today",
    data: {
      restView: null,
      formFilter: null,
      forms: null,
      allCustomers: null,
    },
    functions: {
      clearFilterSelect: function (select) {
        select.selectedIndex = 0;
        select.data = 0;
        Array.from(select.children)
          .filter((option) => option.data)
          .forEach((option) => select.removeChild(option));
      },
      getPrenameFromForm: function (data) {
        data = JSON.parse(data);
        let name = "";
        data
          .filter(
            (i) =>
              (i.name === "Name" || i.name === "Name ") &&
              i.data &&
              i.data.length > 1
          )
          .forEach((i) => {
            if (
              i.data[0].name.toLowerCase().includes("vorname") ||
              i.data[0].name.toLowerCase() === "vname" ||
              i.data[0].name.toLowerCase() === "name2_ag"
            ) {
              name = i.data[0].val;
            } else if (
              i.data[1].name.toLowerCase().includes("vorname") ||
              i.data[1].name.toLowerCase() === "vname" ||
              i.data[1].name.toLowerCase() === "name2_ag"
            ) {
              name = i.data[1].val;
            }
          });
        return name;
      },
      getSurnameFromForm: function (data) {
        data = JSON.parse(data);
        let name = "";
        data
          .filter(
            (i) =>
              (i.name === "Name" || i.name === "Name ") &&
              i.data &&
              i.data.length > 1
          )
          .forEach((i) => {
            if (
              i.data[1].name.toLowerCase().includes("nachname") ||
              i.data[1].name.toLowerCase().includes("zuname") ||
              i.data[1].name.toLowerCase() === "name" ||
              i.data[1].name.toLowerCase() === "name1_ag"
            ) {
              name = i.data[1].val;
            } else if (
              i.data[0].name.toLowerCase().includes("nachname") ||
              i.data[0].name.toLowerCase().includes("zuname") ||
              i.data[0].name.toLowerCase() === "name" ||
              i.data[0].name.toLowerCase() === "name1_ag"
            ) {
              name = i.data[0].val;
            }
          });
        return name;
      },
      removeAllIcons() {
        let allIcons = document.querySelectorAll(
          "#customer_today .material-icons.sorting-icon"
        );
        allIcons = Array.from(allIcons);
        allIcons.map((icon) => {
          icon.parentNode.removeChild(icon);
        });
      },
      rendercustomer_todayTable: function (view) {
        const table = document.querySelector(`#${view.css_id} table.found`);
        const tbody = table.querySelector("tbody");
        tbody.innerHTML = null;

        const trs = [];
        const formToHtml = view.functions.formToHtml;
        const getPrenameFromForm = view.functions.getPrenameFromForm;
        const getSurnameFromForm = view.functions.getSurnameFromForm;
        let counter = 1;

        view.data.allCustomers.map((c) => {
          var tr = document.createElement("tr");
          tr.data = c;

          if (c.locationPartner) {
            tr.insertAdjacentHTML(
              "beforeend",
              `
                                    <td>${counter++}</td>
                                    <td>${c.partner.name}</td>
                                    <td>${c.form.name}</td>
                                    <td>${c.locationPartner.location.name}</td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
            );
          } else {
            tr.insertAdjacentHTML(
              "beforeend",
              `
                                    <td>${counter++}</td>
                                    <td>${c.partner.name}</td>
                                    <td>${c.form.name}</td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
            );
          }

          tr.children[tr.children.length - 1].appendChild(formToHtml(c.data)); //put parsed json to last td of this row
          trs.push(tr);
        });
        requestAnimationFrame(() => {
          trs.map((tr) => tbody.appendChild(tr));
        });
      },
      formToHtml: function (data) {
        data = JSON.parse(data);
        const container = document.createElement("div");
        const table = document.createElement("table");
        table.classList.add("dataset");

        const html = [];
        const signs = []; //stores the paths of signs in the same order like the buttons. The buttons has the attribute data-signIndex to access this array

        //TODO the CPU bottle neck is inside this mal function
        data.map((i) => {
          html.push(`<tr><td>${i.name}</td><td>`);

          if (Array.isArray(i.data)) {
            if (i.data[0] && typeof i.data[0] === "string") {
              html.push("<table>");
              html.push(`<tr><td>${i.data[0]}</td><td></td></tr>`);
              html.push("</table>");
            } else {
              html.push("<table>");
              i.data.map((j) =>
                html.push(`<tr><td>${j.name}</td><td>${j.val}</td></tr>`)
              );
              html.push("</table>");
            }
          } else if (i.val || i.val === "") {
            html.push("<table>");
            html.push(`<tr><td>${i.name}</td><td>${i.val}</td></tr>`);
            html.push("</table>");
          } else {
            let path = i.data.path;
            if (path !== undefined && path.substr(0, 2) === "x,") {
              // -- sign --
              html.push(
                `<button class="sign" data-signIndex="${signs.length}">Unterschrift anzeigen</button>`
              );
              signs.push(path);
            } else {
              html.push("<table>");
              for (let j in i.data) {
                if (typeof i.data[j] === "boolean")
                  html.push(
                    html.push(
                      `<tr><td>${lng.get(j)}</td><td>${
                        i.data[j] ? "Ja" : "Nein"
                      }</td></tr>`
                    )
                  );
                else
                  html.push(
                    `<tr><td>${lng.get(j)}</td><td>${i.data[j]}</td></tr>`
                  );
              }
              html.push("</table>");
            }
          }

          html.push(`</td></tr>`);
        });

        //innerHTML is lightly faster then insertadjacenthtml
        table.innerHTML = html.join("");
        //table.insertAdjacentHTML('beforeend', html.join(''));
        table.signs = signs;
        container.appendChild(table);
        return container;
      },
      updateSelectWidth: function (select, text) {
        if (
          select.selectedIndex === 0 &&
          select.options[select.selectedIndex].innerHTML === text
        ) {
          select.style.width = "100px";
        } else {
          let formText = select.options[select.selectedIndex].data.name;

          if (!formText) {
            formText = select.options[select.selectedIndex].innerHTML;
          }

          select.style.width = 10 + formText.length * 8 + "px";
        }
      },
      updatePartnerGroupSelect: function () {
        const view = CONTENT.CUSTOMER_TODAY;
        const activeToggle = document.querySelector(
          `#${view.css_id} .filter .partnerGroup .activeFlag input`
        );

        const query = !activeToggle.checked
          ? null
          : {
              where: {
                active: true,
              },
            };

        restCollection.partnerGroup.find(query).then((partnerGroups) => {
          partnerGroups = partnerGroups.sort((a, b) =>
            a.name.localeCompare(b.name)
          );

          const options = partnerGroups.map((pg) => {
            const option = document.createElement("option");
            option.textContent = pg.name;
            option.data = pg;
            return option;
          });
          const pgSelect = document.querySelector(
            `#${view.css_id} .filter .partnerGroup select`
          );
          const partnerSelect = document.querySelector(
            `#${view.css_id} .filter .partner select`
          );
          view.functions.clearFilterSelect(pgSelect);
          options.map((o) => pgSelect.appendChild(o));

          view.functions.updateSelectWidth(pgSelect, "Bitte wählen");
          view.functions.updateSelectWidth(partnerSelect, "Bitte wählen");
        });
      },
      updatePartnerSelect: function () {
        const view = CONTENT.CUSTOMER_TODAY;

        const partnerGroupSelect = document.querySelector(
          `#${view.css_id} .filter .partnerGroup select`
        );
        let partnerGroupID;

        if (
          partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data &&
          partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data.id
        ) {
          partnerGroupID =
            partnerGroupSelect.options[partnerGroupSelect.selectedIndex].data
              .id;
        }

        if (!partnerGroupID) {
          return;
        }

        const partnerActiveToggle = document.querySelector(
          `#${view.css_id} .filter .partner .activeFlag input`
        );
        const partnerQuery = {
          partnerGroup: partnerGroupID,
        };
        if (partnerActiveToggle.checked) partnerQuery.active = true;

        restCollection.partner
          .find({
            where: partnerQuery,
          })
          .then((partners) => {
            partners = partners.sort((a, b) => a.name.localeCompare(b.name));

            const options = partners.map((p) => {
              const option = document.createElement("option");
              option.textContent = p.name;
              option.data = p;
              return option;
            });

            const select = document.querySelector(
              `#${view.css_id} .filter .partner select`
            );
            view.functions.clearFilterSelect(select);
            options.map((o) => select.appendChild(o));

            const partnerSelect = document.querySelector(
              `#${view.css_id} .filter .partner select`
            );
            view.functions.updateSelectWidth(partnerSelect, "Bitte wählen");
          });
      },
    },
    init: function (data) {
      const view = CONTENT.CUSTOMER_TODAY;
      //set labels
      const labels = ["startDate", "partnerGroup", "partner", "endDate"];
      let labelItem;
      for (let i = 0; i < labels.length; i++) {
        labelItem = document.querySelector(
          `#customer_today .filter .${labels[i]} label`
        );
        labelItem.innerHTML = lng.get(labels[i]);
      }

      const tr = document.querySelector(`#customer_today .found thead tr`);
      tr.children[0].textContent = lng.get(tr.children[0].textContent);
      tr.children[1].textContent = lng.get(tr.children[1].textContent);
      tr.children[2].textContent = lng.get(tr.children[2].textContent);
      tr.children[3].textContent = lng.get(tr.children[3].textContent);
      tr.children[4].textContent = lng.get(tr.children[4].textContent);
      tr.children[5].textContent = lng.get(tr.children[5].textContent);
      tr.children[6].textContent = lng.get(tr.children[6].textContent);
      tr.children[7].textContent = lng.get(tr.children[7].textContent);
      tr.children[8].textContent = lng.get(tr.children[8].textContent);

      let allSortingLabels = document.querySelectorAll(
        "#customer_today .sorting"
      );
      allSortingLabels = Array.from(allSortingLabels);
      allSortingLabels.forEach((label) => {
        label.insertAdjacentHTML(
          "beforeend",
          '<i class="material-icons sorting-icon default">code</i>'
        );
      });
      view.functions.updatePartnerGroupSelect();
    },
    close: function () {
      // var view = CONTENT.CUSTOMER_TODAY;
      // view.data.restView.destroy();
    },
    events: [
      {
        source: "#customer_today .filter .partnerGroup .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;
          view.functions.updatePartnerGroupSelect();
        },
      },
      {
        source: "#customer_today .filter .partnerGroup select",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;
          const partnerGroupSelect = document.querySelector(
            `#${view.css_id} .filter .partnerGroup select`
          );
          view.functions.updateSelectWidth(partnerGroupSelect, "Bitte wählen");
          view.functions.updatePartnerSelect();
        },
      },
      {
        source: "#customer_today .filter .partner .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;
          view.functions.updatePartnerSelect();
        },
      },
      {
        source: "#customer_today .filter .partner .activeFlag",
        event: "change",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;
          view.functions.updatePartnerSelect();
        },
      },
      {
        source: "#customer_today .sorting.prename",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          const getPrenameFromForm = view.functions.getPrenameFromForm;

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return getPrenameFromForm(a.data).toLowerCase() <
                getPrenameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            } else {
              return getPrenameFromForm(a.data).toLowerCase() >
                getPrenameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            }
          });

          view.functions.rendercustomer_todayTable(view);
        },
      },
      {
        source: "#customer_today .sorting.time",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return new Date(a.date) - new Date(b.date);
            } else {
              return new Date(b.date) - new Date(a.date);
            }
          });

          view.functions.rendercustomer_todayTable(view);
        },
      },
      {
        source: "#customer_today .sorting.form",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return a.form.name < b.form.name ? 1 : -1;
            } else {
              return a.form.name > b.form.name ? 1 : -1;
            }
          });

          view.functions.rendercustomer_todayTable(view);
        },
      },
      {
        source: "#customer_today .sorting.partner",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return a.partner.name < b.partner.name ? 1 : -1;
            } else {
              return a.partner.name > b.partner.name ? 1 : -1;
            }
          });

          view.functions.rendercustomer_todayTable(view);
        },
      },
      {
        source: "#customer_today .sorting.surname",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;

          view.functions.removeAllIcons();

          if (this.classList.contains("ASC")) {
            this.classList.remove("ASC");
            this.classList.add("DESC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_up</i>'
            );
          } else {
            this.classList.remove("DESC");
            this.classList.add("ASC");
            this.insertAdjacentHTML(
              "beforeend",
              '<i class="material-icons sorting-icon">keyboard_arrow_down</i>'
            );
          }

          const getSurnameFromForm = view.functions.getSurnameFromForm;

          view.data.allCustomers.sort((a, b) => {
            if (this.classList.contains("DESC")) {
              return getSurnameFromForm(a.data).toLowerCase() <
                getSurnameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            } else {
              return getSurnameFromForm(a.data).toLowerCase() >
                getSurnameFromForm(b.data).toLowerCase()
                ? 1
                : -1;
            }
          });

          view.functions.rendercustomer_todayTable(view);
        },
      },
      {
        source: "#customer_today .filter button.ok",
        event: "click",
        function: function () {
          const view = CONTENT.CUSTOMER_TODAY;

          view.functions.removeAllIcons();
          const partnerSelect = document.querySelector(
            `#customer_today .partner select`
          );
          let partner = partnerSelect.options[partnerSelect.selectedIndex].data;

          let startDate = document.querySelector(
            `#customer_today .filter input[name=startDate]`
          ).value;
          let endDate = document.querySelector(
            `#customer_today .filter input[name=endDate]`
          ).value;

          const query = {
            formPartnerActive: true,
          };
          if (partner) query.partnerId = partner.id;

          const table = document.querySelector(`#${view.css_id} table.found`);
          const tbody = table.querySelector("tbody");
          if (!startDate && !endDate)
            snackbar.show({
              message: "Abfrage nur mit Datum möglich",
            });
          else {
            query.date = {};
            if (startDate) {
              startDate = new Date(startDate);
              startDate.setUTCHours(0, 0, 0, 0);
              startDate = startDate.toISOString();
              query.date[">="] = startDate;
            }

            if (endDate) {
              endDate = new Date(endDate);
              endDate.setUTCHours(23, 59, 59, 0);
              endDate = endDate.toISOString();
              query.date["<="] = endDate;
            }

            table.classList.add("loading");
            //remove old table content while waiting and parsing the request
            Promise.all([
              restCollection.customer.find({ where: query }),
              new Promise((resolve) => {
                tbody.innerHTML = null;
                resolve();
              }),
            ]).then((customers) => {
              // remove the download-information from the DOM
              let downloadInfo = document.querySelector(".download-info");
              if (downloadInfo && downloadInfo.parentNode) {
                downloadInfo.parentNode.removeChild(downloadInfo);
              }

              customers = customers[0]; //cause Promise.all

              if (customers.length === 0) {
                snackbar.show({
                  message: "Keine Daten für die Anfrage verfügbar.",
                });
              }
              const trs = [];
              const formToHtml = view.functions.formToHtml;
              const getPrenameFromForm = view.functions.getPrenameFromForm;
              const getSurnameFromForm = view.functions.getSurnameFromForm;
              let counter = 1;

              view.data.allCustomers = customers;

              customers.map((c) => {
                var tr = document.createElement("tr");
                tr.data = c;

                if (c.locationPartner) {
                  tr.insertAdjacentHTML(
                    "beforeend",
                    `
                                    <td>${counter++}</td>
                                    <td>${c.partner.name}</td>
                                    <td>${c.form.name}</td>
                                    <td>${c.locationPartner.location.name}</td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
                  );
                } else {
                  tr.insertAdjacentHTML(
                    "beforeend",
                    `
                                    <td>${counter++}</td>
                                    <td>${c.partner.name}</td>
                                    <td>${c.form.name}</td>
                                    <td>${c.employeePartner.employee.name}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleDateString()}</td>
                                    <td>${new Date(
                                      c.date
                                    ).toLocaleTimeString()}</td>
                                    <td>${getPrenameFromForm(c.data)}</td>
                                    <td>${getSurnameFromForm(c.data)}</td>
                                    <td></td>
                                    `
                  );
                }

                tr.children[tr.children.length - 1].appendChild(
                  formToHtml(c.data)
                ); //put parsed json to last td of this row
                trs.push(tr);
              });
              requestAnimationFrame(() => {
                trs.map((tr) => tbody.appendChild(tr));
                table.classList.remove("loading");

                let allSortingLabels = document.querySelectorAll(
                  "#customer_today .sorting"
                );
                allSortingLabels = Array.from(allSortingLabels);
                allSortingLabels.forEach((label) => {
                  label.insertAdjacentHTML(
                    "beforeend",
                    '<i class="material-icons sorting-icon default">code</i>'
                  );
                });
              });
            });
          }
        },
      },
      {
        source: "#customer_today .found button.sign",
        event: "click",
        function: function () {
          const td = this.parentNode;

          //find table
          let table = this;
          do {
            table = table.parentNode;
          } while (
            !table.classList.contains("dataset") &&
            table !== document.body
          );

          //get sign from table

          if (!table.signs) {
            console.error("signs not found on table");
            return;
          }

          const signIndex = parseInt(this.dataset.signindex, 10);
          let path = table.signs[signIndex];

          if (!path) {
            console.error("sign not found in array");
            return;
          }

          const canvas = createSign(path);

          requestAnimationFrame(() => {
            td.removeChild(this);
            td.appendChild(canvas);
          });
        },
      },
    ],
  },
  CONTRACT: {
    css_id: "contract",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.CONTRACT;
      const rest = restCollection.contract;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.CONTRACT;
      view.data.restView.destroy();
    },
    events: [],
  },
  CONTRACT_BLUEPRINT: {
    css_id: "contract_blueprint",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.CONTRACT_BLUEPRINT;
      const rest = restCollection.contractBlueprint;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.CONTRACT_BLUEPRINT;
      view.data.restView.destroy();
    },
    events: [],
  },
  EMPLOYEE: {
    css_id: "employee",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.EMPLOYEE;
      const rest = restCollection.employee;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.EMPLOYEE;
      view.data.restView.destroy();
    },
    events: [],
  },
  LOCATION: {
    css_id: "location",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.LOCATION;
      const rest = restCollection.location;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.LOCATION;
      view.data.restView.destroy();
    },
    events: [],
  },
  FORM: {
    css_id: "form",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.FORM;
      const rest = restCollection.form;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.FORM;
      view.data.restView.destroy();
    },
    events: [],
  },
  FORM_EXPORT_CSV: {
    css_id: "formExportCsv",
    data: {
      restView: null,
      parentForm: null,
      configBuilder: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.FORM_EXPORT_CSV;
      const rest = restCollection.formExportCsv;

      if (data && data.form) view.data.parentForm = data.form;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.FORM_EXPORT_CSV;
      view.data.restView.destroy();
      view.data.parentForm = null;
    },
    events: [],
  },
  FORM_EXPORT_XML: {
    css_id: "formExportXml",
    data: {
      restView: null,
      parentForm: null,
      configBuilder: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.FORM_EXPORT_XML;
      const rest = restCollection.formExportXml;

      if (data && data.form) view.data.parentForm = data.form;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.FORM_EXPORT_XML;
      view.data.restView.destroy();
      view.data.parentForm = null;
    },
    events: [],
  },
  FORM_EXPORT_PDF: {
    css_id: "formExportPdf",
    data: {
      restView: null,
      parentForm: null,
      configBuilder: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.FORM_EXPORT_PDF;
      const rest = restCollection.formExportPdf;

      if (data && data.form) view.data.parentForm = data.form;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.FORM_EXPORT_PDF;
      view.data.restView.destroy();
      view.data.parentForm = null;
    },
    events: [],
  },
  AUTO_EXPORT: {
    css_id: "auto_export",
    data: {
      restView: null,
    },
    functions: {},
    init: function (data) {
      const view = CONTENT.AUTO_EXPORT;
      const rest = restCollection.automaticExport;

      view.data.restView = new RestView(view, rest, data);
    },
    close: function () {
      const view = CONTENT.AUTO_EXPORT;
      view.data.restView.destroy();
    },
    events: [],
  },
  /* ---- Contetnt end ---- */
};

/* ----------- CONTENT END ------------- */
